<pre>
    {{data.data | json}}
</pre>